<div class="modal-header">
  <div class="d-flex justify-content-between align-items-center w-100 me-4">
    <h4 class="modal-title mb-0">
      <i class="fa fa-users text-primary me-2"></i>
      {{ 'companyProfile.membershipPlans.viewMembers.title' | translate }} - {{ plan.name }}
    </h4>
    <button type="button" class="btn btn-sm btn-primary" (click)="openAddMemberModal()">
      <i class="fa fa-user-plus me-2"></i>{{ 'companyProfile.membershipPlans.viewMembers.addMember' | translate }}
    </button>
  </div>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | translate" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <!-- Stats Cards -->
  <div class="row g-4 mb-5">
    <div class="col-4">
      <div class="stat-card success">
        <div class="stat-icon">
          <i class="fa fa-check-circle"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ activeCount }}</div>
          <div class="stat-label">{{ 'companyProfile.membershipPlans.viewMembers.active' | translate }}</div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="stat-card warning">
        <div class="stat-icon">
          <i class="fa fa-clock"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ pendingCount }}</div>
          <div class="stat-label">{{ 'companyProfile.membershipPlans.viewMembers.pending' | translate }}</div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="stat-card danger">
        <div class="stat-icon">
          <i class="fa fa-times-circle"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ expiredCount }}</div>
          <div class="stat-label">{{ 'companyProfile.membershipPlans.viewMembers.expired' | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filters -->
  <div class="filter-row">
    <div class="filter-search">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="searchQuery"
        [placeholder]="'companyProfile.membershipPlans.viewMembers.searchPlaceholder' | translate"
        (ngModelChange)="onSearchChange()"
      />
    </div>
    <div class="filter-status">
      <select class="form-select" [(ngModel)]="statusFilter" (ngModelChange)="onStatusFilterChange()">
        <option value="all">{{ 'companyProfile.membershipPlans.viewMembers.allStatuses' | translate }}</option>
        <option value="active">{{ 'companyProfile.membershipPlans.viewMembers.active' | translate }}</option>
        <option value="pending">{{ 'companyProfile.membershipPlans.viewMembers.pending' | translate }}</option>
        <option value="expired">{{ 'companyProfile.membershipPlans.viewMembers.expired' | translate }}</option>
        <option value="cancelled">{{ 'companyProfile.membershipPlans.viewMembers.cancelled' | translate }}</option>
      </select>
    </div>
    <div class="filter-count">
      <span class="member-count-badge">{{ filteredMemberships.length }} {{ 'companyProfile.membershipPlans.members' | translate }}</span>
    </div>
  </div>

  <!-- Members Table -->
  @if (filteredMemberships.length === 0) {
    <div class="d-flex flex-column align-items-center py-10">
      <i class="fa fa-users fs-3x text-muted mb-3"></i>
      <p class="text-muted mb-0">{{ 'companyProfile.membershipPlans.viewMembers.noMembersFound' | translate }}</p>
    </div>
  } @else {
    <div class="table-responsive">
      <table class="table table-row-bordered align-middle">
        <thead>
          <tr class="fw-bold text-muted">
            <th>{{ 'companyProfile.membershipPlans.viewMembers.member' | translate }}</th>
            <th>{{ 'companyProfile.membershipPlans.viewMembers.email' | translate }}</th>
            <th>{{ 'companyProfile.membershipPlans.viewMembers.phone' | translate }}</th>
            <th>{{ 'companyProfile.membershipPlans.viewMembers.status' | translate }}</th>
            <th>{{ 'companyProfile.membershipPlans.viewMembers.payment' | translate }}</th>
            <th>{{ 'companyProfile.membershipPlans.viewMembers.started' | translate }}</th>
            <th>{{ 'companyProfile.membershipPlans.viewMembers.expires' | translate }}</th>
            <th class="text-end" style="min-width: 100px;">{{ 'companyProfile.membershipPlans.viewMembers.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (membership of filteredMemberships; track membership.membership_id) {
            <tr [class.cursor-pointer]="membership.owner_type === 'family' && getFamilyMemberCount(membership) > 0"
                (click)="membership.owner_type === 'family' && getFamilyMemberCount(membership) > 0 ? toggleFamilyExpand(membership) : null">
              <td>
                <div class="d-flex align-items-center">
                  <div class="symbol symbol-35px me-3">
                    <span class="symbol-label fw-bold"
                      [class.bg-light-primary]="membership.owner_type === 'user'"
                      [class.text-primary]="membership.owner_type === 'user'"
                      [class.bg-light-warning]="membership.owner_type === 'manual'"
                      [class.text-warning]="membership.owner_type === 'manual'"
                      [class.bg-light-info]="membership.owner_type === 'family'"
                      [class.text-info]="membership.owner_type === 'family'">
                      {{ getMemberInitial(membership) }}
                    </span>
                  </div>
                  <div>
                    <span class="fw-bold">{{ getMemberName(membership) }}</span>
                    @if (membership.owner_type === 'family') {
                      <span class="badge badge-light-info ms-2">
                        <i class="fa fa-users me-1"></i>
                        {{ getFamilyMemberCount(membership) }} {{ 'companyProfile.membershipPlans.viewMembers.familyMembers' | translate }}
                        @if (getFamilyMemberCount(membership) > 0) {
                          <i class="fa ms-1" [class.fa-chevron-down]="!isFamilyExpanded(membership)" [class.fa-chevron-up]="isFamilyExpanded(membership)"></i>
                        }
                      </span>
                    }
                    @if (membership.owner_type === 'manual') {
                      <span class="badge badge-light-warning ms-2">{{ 'companyProfile.membershipPlans.viewMembers.manual' | translate }}</span>
                    }
                  </div>
                </div>
              </td>
              <td>{{ getMemberEmail(membership) }}</td>
              <td>{{ getMemberPhone(membership) }}</td>
              <td>
                <span class="badge" [ngClass]="getStatusBadgeClass(membership.status)">
                  {{ membership.status | titlecase }}
                </span>
              </td>
              <td>
                <span class="badge" [ngClass]="getPaymentBadgeClass(membership.payment_status)">
                  {{ membership.payment_status | titlecase }}
                </span>
              </td>
              <td>{{ formatDate(membership.started_at) }}</td>
              <td>{{ formatDate(membership.expires_at) }}</td>
              <td class="text-end">
                <div class="d-flex justify-content-end gap-1">
                  <button
                    type="button"
                    class="btn btn-sm btn-icon btn-light-primary"
                    [title]="'common.edit' | translate"
                    (click)="openEditModal(membership, $event)"
                  >
                    <i class="fa fa-pencil-alt"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-icon btn-light-danger"
                    [title]="'common.delete' | translate"
                    (click)="deleteMembership(membership, $event)"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
            <!-- Expanded family members row -->
            @if (membership.owner_type === 'family' && isFamilyExpanded(membership)) {
              <tr class="family-members-row">
                <td colspan="8" class="p-0">
                  <div class="family-members-container">
                    <div class="family-members-header d-flex justify-content-between align-items-center">
                      <div>
                        <i class="fa fa-users me-2"></i>
                        {{ 'companyProfile.membershipPlans.viewMembers.familyMembersList' | translate }}
                      </div>
                      <button
                        type="button"
                        class="btn btn-sm btn-light-primary"
                        (click)="openAddFamilyMemberModal(membership, $event)"
                      >
                        <i class="fa fa-user-plus me-1"></i>
                        {{ 'companyProfile.membershipPlans.editMember.addFamilyMember' | translate }}
                      </button>
                    </div>

                    <div class="family-members-list">
                      @for (member of getFamilyMembers(membership); track member.user.user_id) {
                        <div class="family-member-item">
                          <div class="symbol symbol-30px me-2">
                            <span class="symbol-label fw-bold bg-light-secondary text-muted">
                              {{ getFamilyMemberInitial(member) }}
                            </span>
                          </div>
                          <div class="family-member-info flex-grow-1">
                            <span class="fw-semibold">{{ getFamilyMemberName(member) }}</span>
                            <span class="badge ms-2" [ngClass]="getRoleBadgeClass(member.role)">
                              {{ member.role | titlecase }}
                            </span>
                          </div>
                          <div class="family-member-contact text-muted flex-grow-1">
                            @if (member.user.email) {
                              <span class="me-3"><i class="fa fa-envelope me-1"></i>{{ member.user.email }}</span>
                            }
                            @if (member.user.phone) {
                              <span><i class="fa fa-phone me-1"></i>{{ member.user.phone }}</span>
                            }
                          </div>
                          <!-- Remove button (not for owner) -->
                          @if (!isOwner(member)) {
                            <button
                              type="button"
                              class="btn btn-sm btn-icon btn-light-danger ms-2"
                              [title]="'companyProfile.membershipPlans.editMember.removeFamilyMember' | translate"
                              (click)="removeFamilyMember(membership, member, $event)"
                            >
                              <i class="fa fa-times"></i>
                            </button>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }
</div>

<div class="modal-footer">
  <app-button
    [variant]="'ghost'"
    [label]="'common.close' | translate"
    (clicked)="activeModal.dismiss()"
  />
</div>
